import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import PriceBadge from "./PriceBadge";

export default function CategoryCard({ category, index = 0 }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-8% 0px" }}
      transition={{ duration: 0.75, delay: (index % 4) * 0.08, ease: [0.22, 1, 0.36, 1] }}
      className="group"
    >
      <Link
        to={`/categories/${category.slug}`}
        className="block card-flat"
        data-testid={`category-card-${category.slug}`}
      >
        <div className="relative overflow-hidden aspect-[4/3] bg-gradient-to-br from-[#F5F7FA] to-[#ECEFF4] flex items-center justify-center p-4">
          <img
            src={category.image}
            alt={`${category.name} rental car — ${category.example}`}
            className="w-full h-full object-contain group-hover:scale-[1.06] transition-transform duration-[900ms] ease-[cubic-bezier(0.22,1,0.36,1)]"
            loading="lazy"
          />
          <div className="absolute top-4 left-4">
            <PriceBadge price={category.startingFrom} size="sm" tone="solid" />
          </div>
        </div>

        <div className="p-3 md:p-6">
          <div className="flex items-start justify-between gap-2">
            <div className="min-w-0">
              <div className="overline mb-1 md:mb-2 text-[9px] md:text-[10px]">Category · {String(index + 1).padStart(2, "0")}</div>
              <h3 className="font-serif text-lg md:text-3xl text-[#0B2545] leading-tight truncate">
                {category.name}
              </h3>
            </div>
            <ArrowUpRight
              className="h-4 w-4 md:h-5 md:w-5 text-[#0B2545] shrink-0 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-transform duration-500"
              strokeWidth={1.5}
            />
          </div>
          <p className="mt-1.5 md:mt-3 text-[11px] md:text-sm text-[#5B6472] leading-snug md:leading-relaxed line-clamp-2">{category.tagline}</p>
          <p className="hidden md:block mt-3 text-xs text-[#0B2545]/70 font-mono">{category.example}</p>
        </div>
      </Link>
    </motion.div>
  );
}
